import 'css-chunksrc/client/common/filterMenu/resourceTags/tag/styles.scss';export default {
  "tag": "_tag_yqbas_1",
  "name": "_name_yqbas_11"
};